import styles from './page-preloader.module.scss';

export function PagePreloader() {
  return (
    <div className={styles.pagePreloader} />
  );
}
